const state = {
    itens: [],
    item: {
        id: null,
        name: ''
    }
};

export default state;